import { render, staticRenderFns } from "./potential-classes.vue?vue&type=template&id=7ca5eab4&scoped=true&"
import script from "./potential-classes.vue?vue&type=script&lang=js&"
export * from "./potential-classes.vue?vue&type=script&lang=js&"
import style0 from "./potential-classes.vue?vue&type=style&index=0&id=7ca5eab4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca5eab4",
  null
  
)

export default component.exports